import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { StoreContext } from 'store/context'
import AddAthleteButtonComponent from './component'

export const AddAthleteButton = combine(
  withContext('appStore', StoreContext),
  withCallbacks(
    {
      loadTeamById:
        ({ appStore }) =>
        (teamId) => {
          appStore.adminTeams.loadTeamById(teamId)
        },
    },
    []
  )
)(AddAthleteButtonComponent)
